export default "<div class=\"page-header\">\n    <h1>help</h1>\n</div>\n<div ta-bind ng-model=\"league.leagueData.leaguesettings.helpContent\"></div>";